import { FC, ReactElement } from 'react';
import styles from './styles.module.scss';
import { MainButton } from '@/shared/MainButton';

interface Props {
  buttonId: string;
  title: ReactElement;
  buttonTitle: ReactElement;
  buttonHandler: () => void;
}

export const PageHeader: FC<Props> = ({
  buttonId,
  title,
  buttonTitle,
  buttonHandler,
}) => {
  return (
    <div className="section">
      <div className={`container ${styles.container}`}>
        <h3>{title}</h3>
        <MainButton
          id={buttonId}
          className={styles.button}
          text={buttonTitle}
          onClick={buttonHandler}
        />
      </div>
    </div>
  );
};
